export default __webpack_public_path__ + "static/media/decoracion-icon.ac8d11e2.svg";